{
  "actionbar.clearSelection": "Clear selection",
  "actionbar.selected": "{count, plural, =0 {None selected} other {# selected}}",
  "actionbar.selectedAll": "All selected",
  "actionbar.actions": "Actions",
  "actionbar.actionsAvailable": "Actions available.",
  "button.pending": "pending",
  "contextualhelp.info": "Information",
  "contextualhelp.help": "Help",
  "dialog.dismiss": "Dismiss",
  "dialog.alert": "Alert",
  "dropzone.replaceMessage": "Drop file to replace",
  "inlinealert.negative": "Error",
  "inlinealert.notice": "Warning",
  "inlinealert.informative": "Information",
  "inlinealert.positive": "Success",
  "label.(required)": "(required)",
  "label.(optional)": "(optional)",
  "menu.moreActions": "More actions",
  "picker.placeholder": "Select…",
  "slider.minimum": "Minimum",
  "slider.maximum": "Maximum",
  "table.loading": "Loading…",
  "table.loadingMore": "Loading more…",
  "table.sortAscending": "Sort Ascending",
  "table.sortDescending": "Sort Descending",
  "table.resizeColumn": "Resize column",
  "tag.showAllButtonLabel": "Show all ({tagCount, number})",
  "tag.hideButtonLabel": "Show less",
  "tag.actions": "Actions",
  "tag.noTags": "None",
  "breadcrumbs.more": "More items"
}